import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import type { SearchResultItem } from '../../compound-components/model';
import { SearchResultCardComponent } from '../../compound-components/search-display/search-results/result-card/search-result-card.component';

/**
 * Dialog that shows a single pipeline embedding feature using SearchResultCardComponent.
 * Opened when the user clicks an embedding feature on the map.
 */
@Component({
  selector: 'lib-pipeline-embeddings-detail-dialog',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButton, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose, SearchResultCardComponent],
  template: `
    <h2 mat-dialog-title>Embedding tile</h2>
    <mat-dialog-content>
      <app-search-result-card
        [item]="data"
        [showFeedback]="false"
        [imageHeight]="320"
        [imageWidth]="320" />
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button matButton mat-dialog-close>Close</button>
    </mat-dialog-actions>
  `,
  styles: [` mat-dialog-content { padding: 0; } `],
})
export class PipelineEmbeddingsDetailDialogComponent {
  readonly data = inject<SearchResultItem>(MAT_DIALOG_DATA);
}
